const GA_TRACKING_ID = 'UA-75391500-53'

// 如果類型為 page 第二個參數為物件參數，可以傳遞頁面路徑
// 如果類型為 event 第二個參數為事件名稱，第三個參數為物件參數，可以傳遞事件細節
function track (type = 'page', opts, eventParams) {
  if (!window.gtag) {
    return
  }

  if (type === 'user') {
    window.gtag('config', GA_TRACKING_ID, {
      user_id: opts.id,
      send_page_view: false
    })
  }

  if (type === 'page') {
    window.gtag('config', GA_TRACKING_ID, {
      page_path: opts.path,
      user_id: opts.id
    })
  }

  if (type === 'event') {
    const eventName = opts

    window.gtag('event', eventName, {
      event_category: eventParams.category,
      event_label: eventParams.label,
      value: eventParams.value
    })
  }
}

export default track
